import Table from "../../Components/UI/Table/Table";
import { Row } from "react-bootstrap";
import { convertUtcToLocal } from "../../utils/functions";
import moment from "moment"; 
import { IReduxState } from "../../utils/types";
import { useSelector } from "react-redux";

interface Props {
    historyData: any,
    upload_segmets:any,
}
const ListComponent =  ({ historyData, upload_segmets }: Props)=>{ 
    const adminState = useSelector((state: IReduxState) => state.Auth);
    const getRemainedTime =(endDate:any,startDate:any)=>{
      let et = moment(endDate);
      let st = moment(new Date());
      let duration = moment.duration(et.diff(st)); 
      let days = Math.ceil(duration.asDays())>0?Math.ceil(duration.asDays()):0;
      return days + ' days';
    }
    let columns = [
        {
            Header: "Start Date",
            accessor: "startDate",
            minWidth: 100,
            Cell: ({ row }: any) =>
            `${convertUtcToLocal(row.original.startDate,'DD/MM/YYYY')}`,
        },
        {
            Header: "Start Time",
            accessor: "",
            minWidth: 100,
            Cell: ({ row }: any) =>
            `${convertUtcToLocal(row.original.startDate,'HH:mm')}`,
        },
        {
            Header: "User ID Type",
            accessor: "type",
            Cell: ({ row }: any) => 
            `${row.original.type ==='BEESWAX'?'WEB_ID':row.original.type}`,
        }, 
        {
            Header: "Upload Type",
            accessor:"uploadType"
        },
        {
            Header: "Value #1",
            accessor: "value1",
            Cell: ({ row }: any) =>  `${row.original.uploadType === 'Single Users'?row.original.values?.[0]:row.original.fileName}`
        },
        {
            Header: "Value #2",
            accessor: "value2",
            Cell: ({ row }: any) =>  <div>{row.original.values?.[1]}</div>
        },
        {
            Header: "Value #3",
            accessor: "value3",
            Cell: ({ row }: any) =>  <div>{row.original.values?.[2]}</div>
        },
        {
            Header: "Value #4",
            accessor: "value4",
            Cell: ({ row }: any) =>  <div>{row.original.values?.[3]}</div>
        },
        {
            Header: "Value #5",
            accessor: "value5",
            Cell: ({ row }: any) =>  <div>{row.original.values?.[4]}</div>
        },
        {
            Header: "Value #6",
            accessor: "value6",
            Cell: ({ row }: any) =>  <div>{row.original.values?.[5]}</div>
        },
        {
            Header: "Time Remaining",
            accessor: "",
            Cell: ({ row }: any) =>  `${getRemainedTime(row.original.endDate,row.original.startDate)}`,       
        },
    ];
    const sizePerPageList = [
        {
          text: "5",
          value: 5,
        },
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "50",
          value: 50,
        },
    ];
 
    if (columns && adminState.role.includes("admin")) {
      let newColumn:any= {
        Header: "ID",
        accessor: "user",
        minWidth: 100
      };
      columns.splice(2, 0,newColumn); 
    }

    if (columns && upload_segmets.length > 0) {
      let newColumn:any= {
        Header: "Campaign",
        accessor: "campaign",
        minWidth: 100
      };
      columns.splice(3, 0,newColumn); 
    }
    
    
    return (
      <>
        <Row><h3 className="module_title" style={{margin:10}}>History</h3></Row>
        <Table
          columns={columns}
          data={historyData}
          pageSize={10}
          sizePerPageList={sizePerPageList}
          isSortable={false}
          pagination={true}
          isSearchable={false}
        />
      </>
    );
}
export default ListComponent;